import { render, staticRenderFns } from "./BlogSideBar.vue?vue&type=template&id=8275e3c8&"
import script from "./BlogSideBar.vue?vue&type=script&lang=js&"
export * from "./BlogSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports